import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { NotificationCentre } from '@dbk/ui-icons';
import Badge from '@dbk/ui-badge';
import NotificationModal from '../../../screens/notifications';
import { PALETTE, KEY_CODE } from '../../../constants';

class NotificationAlert extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: false,
    };
  }

  handlePressed(e) {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      this.setState((prevState) => ({ selected: !prevState.selected }));
    }
  }

  handleCloseModal() {
    this.setState({ selected: false });
  }

  render() {
    const { onChange, notifications: { userNotifications }, i18n: { messages }, } = this.props;
    const notificationClass =
      userNotifications && userNotifications.totalDisplay > 0
        ? ' '
        : 'margin-left-20';
    const counter = userNotifications && userNotifications.totalDisplay;
    return (
      <div onKeyDown={(e) => this.handlePressed(e)}>
        <TouchableOpacity
          id="icon_notification_notificationAlert_test"
          onPress={() => this.handlePressed()}
          accessibilityRole="button"
          accessibilityLabel={counter > 0 ? messages['app.dash.accessibility.link.notification'] + `${counter}`: messages['app.dash.accessibility.link.notification']}
        >
          <span className={'notification-icon-position'} >
            <span tabIndex={-1} className={'badge-position'}>
              {counter > 0 && !this.state.selected && <Badge value={counter} />}
            </span>
            {this.state.selected ? (
              <span className={'margin-left-20'}>
                <NotificationCentre width={24} height={24} color={PALETTE.primaryActive} />
              </span>
            ) : (
              <span className={notificationClass}>
                <NotificationCentre width={24} height={24} color={PALETTE.primaryText}/>
              </span>
            )}
          </span>
        </TouchableOpacity>
        {this.state.selected && (
          <NotificationModal onChange={() => this.handleCloseModal()} />
        )}
      </div>
    );
  }
}

NotificationAlert.propTypes = {
  selected: PropTypes.bool,
  onChange: PropTypes.func,
};

export default createContainer({
  $queries: {
    rsa: {
      onChangePage: { $call: 'changePage' },
    },
    notifications: {
      userNotifications: true,
    },
    i18n: {
      messages: true,
    },
  },
})(NotificationAlert);
